import { AlertCircle } from 'lucide-react'
import { Button, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import '../../../styles/style.css'
function ModalCancelSlotLocation(props) {
  const navigate = useNavigate()
  return (
    <>
      <Modal {...props} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="p-5">
          <div className="text-center">
            <AlertCircle color="grey" size={100} className="ml-2" />
          </div>
          <div className="text-center mt-3">
            <h5>Cancel?</h5>
            <p className="mt-2 fw-bold">Change will be discarded</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="transparent" onClick={props.onHide}>
            Continue Update
          </Button>
          <Button
            variant="danger"
            onClick={() =>
              navigate('/outbound/sj/create', {
                state: {
                  resultCustomerDeliveryPlan:
                    props.stateData.resultCustomerDeliveryPlan,
                  pickupCommands: props.prevSlots
                }
              })
            }
          >
            OK, Discard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ModalCancelSlotLocation
